import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    var options = {
      filter_functions : {
        // Add these options to the select dropdown (regex example)
        2 : {
          "Common" : function(e, n, f, i) { return /C/.test(e); },
          "Uncommon" : function(e, n, f, i) { return /U/.test(e); },
          "Rare" : function(e, n, f, i) { return /R/.test(e); },
          "Mythic" : function(e, n, f, i) { return /M/.test(e); },
          "Special" : function(e, n, f, i) { return /S/.test(e); },
        }
      }
    };
    var types = ["online", "paper"];
    for (var i=0; i < types.length; i++) {
      var type = types[i];
      bindTablesorter($(".tablesorter-bootstrap-popover-" + type), {}, options, type, true);
    }
  }
}
